import { useReducer } from "react";
import Slider from "./Slider";

const initialState = {
  additionalPrice: 0,
  kitchen: {
    price: 0,
    name: "Quote Calculator",
    image:
      "https://images.unsplash.com/photo-1600585152220-90363fe7e115?ixid=MnwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8&ixlib=rb-1.2.1&auto=format&fit=crop&w=750&q=80",
    features: [],
  },
  store: [
    { id: 1, name: "24 hour fitting", price: 0.2 },
    { id: 2, name: "Silicon seal waterproofing", price: 0.1 },
    { id: 3, name: "Appliance setup", price: 0.5 },
    { id: 4, name: "Plumbing setup", price: 0.5 },
  ],
};

const reducer = (state, action) => {
  switch (action.type) {
    case "UPDATE_STEP": {
      return {
        ...state,
        kitchen: {
          ...state.kitchen,
          price: action.step,
        },
      };
    }
    case "REMOVE_ITEM":
      return {
        ...state,
        additionalPrice:
          state.additionalPrice - state.kitchen.price * action.item.price,
        kitchen: {
          ...state.kitchen,
          features: state.kitchen.features.filter(
            (x) => x.id !== action.item.id
          ),
        },
        store: [...state.store, action.item],
      };
    case "BUY_ITEM":
      return {
        ...state,
        additionalPrice:
          state.kitchen.price * action.item.price + state.additionalPrice,
        kitchen: {
          ...state.kitchen,
          features: [...state.kitchen.features, action.item],
        },
        store: state.store.filter((x) => x.id !== action.item.id),
      };
    default:
      return state;
  }
};

const App = () => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const removeFeature = (item) => {
    dispatch({ type: "REMOVE_ITEM", item });
  };

  const buyItem = (item) => {
    dispatch({ type: "BUY_ITEM", item });
  };

  const totalAmount = state.kitchen.price + state.additionalPrice;

  return (
    <div className="flex flex-col justify-center">
      <header className="h-16 text-white bg-dark">
        <div className="container relative mx-auto">
          <div class="absolute w-auto h-auto bg-primary top-0 rounded-bl-lg rounded-br-lg p-4">
            <div className="flex items-center">
              <svg
                className="w-8 h-8 mr-2"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 7h6m0 10v-3m-3 3h.01M9 17h.01M9 14h.01M12 14h.01M15 11h.01M12 11h.01M9 11h.01M7 21h10a2 2 0 002-2V5a2 2 0 00-2-2H7a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>
              <div className="flex items-center h-12">
                <p className="my-0 text-base font-bold tracking-normal text-left text-white uppercase">
                  Quotr
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="container relative flex h-16 mx-auto">
          <div className="flex items-center self-center ml-auto font-semibold text-white">
            <a
              className="text-sm opacity-50 hover:opacity-100"
              href="http://www.danielcranney.com"
              target="_blank"
              rel="noreferrer"
            >
              A project by Daniel Cranney
            </a>
          </div>
        </div>
      </header>

      <div className="flex w-full mx-auto bg-lightGray">
        <div className="container flex pt-16 pb-10 mx-auto my-auto">
          <div>
            <h2>{state.kitchen.name}</h2>
            <p className="opacity-70">
              This is a demo website, showing what Quotr can do. This demo was
              made for a kitchen fitter, and the additional services that come
              with this kind of trade.
            </p>
          </div>
        </div>
      </div>

      <div className="container flex self-center gap-16 py-8 mx-auto rounded-lg">
        {/* <div className="w-1/4 pl-0 pr-4 box">
          <figure className="image is-128x128">
            <img src={state.kitchen.image} className="rounded-lg" />
          </figure>
        </div> */}

        {/* Left */}
        <div className="flex flex-col w-3/5">
          {/* Base cost */}
          <div className="w-full pb-12 border-b-2 border-lightGray">
            <h4>Base cost:</h4>
            <p className="opacity-75">
              How much did you purchase your kitchen for?
            </p>
            {/* £{state.kitchen.price} */}
            <Slider
              onChange={(value) =>
                dispatch({
                  type: "UPDATE_STEP",
                  step: value,
                })
              }
            />
          </div>

          {/* Additional features */}
          <div className="w-full mt-8">
            <h4>Additional Services:</h4>
            <p className="mb-8 opacity-75">
              Select from some of our additional services.
            </p>
            {state.store.length ? (
              <ol type="1" className="flex flex-wrap justify-between">
                {state.store.map((item) => (
                  <li
                    key={item.id}
                    className="flex items-center p-2 my-2 border rounded-full bg-lightGray border-darkerGray w-49pc"
                  >
                    <button
                      onClick={() => buyItem(item)}
                      className="w-10 h-10 mr-2 button"
                    >
                      {/* Plus */}
                      <svg
                        className="w-6 h-6 mx-auto my-auto"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M12 6v6m0 0v6m0-6h6m-6 0H6"
                        />
                      </svg>
                    </button>
                    {item.name}
                    {/* &nbsp; (+{item.price}) */}
                  </li>
                ))}
              </ol>
            ) : (
              <p>You've added all of our additional features!</p>
            )}
          </div>
        </div>

        {/* Right */}
        <div className="flex flex-col w-2/5 p-10 border rounded-lg bg-lightGray border-darkerGray">
          {/* Your order includes */}
          <div className="w-full mb-4">
            <h4>Your estimate includes:</h4>
            {state.kitchen.features.length ? (
              <ol type="1">
                {state.kitchen.features.map((item) => (
                  <li
                    key={item.id}
                    className="flex items-center w-full p-2 my-2 border rounded-full bg-mediumGray border-darkerGray"
                  >
                    <button
                      onClick={() => removeFeature(item)}
                      className="w-10 h-10 mr-2 button"
                    >
                      {/* Multiply */}
                      <svg
                        className="w-6 h-6 mx-auto my-auto"
                        fill="none"
                        stroke="currentColor"
                        viewBox="0 0 24 24"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          strokeWidth={2}
                          d="M6 18L18 6M6 6l12 12"
                        />
                      </svg>
                    </button>
                    {item.name}
                  </li>
                ))}
              </ol>
            ) : (
              <p>You have not added anything yet!</p>
            )}
          </div>

          {/* Total cost */}
          <div className="flex items-center justify-center w-full h-48 mt-auto rounded-lg bg-dark">
            <div className="text-center">
              <p className="font-bold text-white opacity-75">Your Quote:</p>
              <p className="text-6xl font-bold text-white">
                {" "}
                £{totalAmount.toFixed(2)}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
